import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  summary: {
    id: 'frontbucket.dashboard.overview.pullRequest.lastUpdatedSummary',
    description:
      'Text describing the pull request: the author, ID, and how recently it was updated',
    defaultMessage: '{author} - #{id}, created {created}, updated {date}',
  },
  summaryWithoutCreated: {
    id: 'frontbucket.dashboard.overview.pullRequest.lastUpdatedSummaryWithoutCreated',
    description:
      'Text describing the pull request: the author, ID, and how recently it was updated',
    defaultMessage: '{author} - #{id}, updated {date}',
  },
  summaryWithRepository: {
    id: 'frontbucket.dashboard.overview.pullRequest.lastUpdatedSummaryWithRepository',
    description:
      'Text describing the pull request: the author, ID, how recently it was updated, and in which repository',
    defaultMessage: '{author} - #{id}, {date} in {repository}',
  },
  taskCount: {
    id: 'frontbucket.dashboard.overview.pullRequest.taskCount',
    description: 'Text to display the number of open tasks on a pull request.',
    defaultMessage:
      '{taskCount, plural, one {{taskCount} open task} other {{taskCount} open tasks}}',
  },
});

export const buildStatusMessages = defineMessages({
  buildFailureTitle: {
    id: 'frontbucket.dashboard.overview.pullRequest.buildFailure',
    description: 'Title text to display when loading the build statuses fails.',
    defaultMessage: 'Oops!',
  },
  buildFailureDescription: {
    id: 'frontbucket.dashboard.overview.pullRequest.buildFailureDescription',
    description:
      'Descriptive text to display when loading the build statuses fails.',
    defaultMessage: `We couldn't load commit statuses for that pull request.`,
  },
});
